import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/geUMFtNkoSD5TQm9npdRAG/WhatsApp_Image_2026-06-30_at_21.56.37.jpg',
  label: 'Low Fade + Textura',
  tag: 'Corte'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uYNkW9BomNKgZEPiNnGsFs/WhatsApp_Image_2026-06-30_at_21.56.37_(1).jpg',
  label: 'El ritual Okrim',
  tag: 'Detrás de escena'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/thWvgW4R3oTTfyEQXZayDJ/WhatsApp_Image_2026-06-30_at_21.56.36.jpg',
  label: 'Mullet + Fade',
  tag: 'Corte'
}];
export function Gallery() {
  return <section id="galeria" className="py-24 bg-zinc-900 relative overflow-hidden" data-id="element-117">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[1px] bg-gradient-to-r from-transparent via-zinc-700 to-transparent" data-id="element-118"></div>

      <div className="container mx-auto px-6" data-id="element-119">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-120">
          <div data-id="element-121">
            <span className="block text-[11px] sm:text-xs font-display uppercase tracking-[0.35em] text-red-500 mb-4" data-id="element-122">
              Portfolio
            </span>
            <h2 className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight text-zinc-50 mb-4" data-id="element-123">
              Trabajos Recientes
            </h2>
            <p className="text-zinc-400 max-w-md font-light" data-id="element-124">
              Un vistazo a lo que hacemos todos los días. Calidad, precisión y
              estilo en cada corte.
            </p>
          </div>
          <a href="https://instagram.com/okrim_barber" target="_blank" rel="noreferrer" className="text-red-500 hover:text-red-400 font-display uppercase tracking-widest text-sm font-bold flex items-center gap-2 transition-colors" data-id="element-125">
            Ver más en Instagram &rarr;
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-126">
          {images.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.12,
          duration: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} className="group relative aspect-[4/5] rounded-2xl overflow-hidden bg-zinc-950 ring-1 ring-white/5 hover:ring-red-500/40 transition-all duration-500" data-id="element-127">
              {/* Bottom gradient for legibility + brand tint */}
              <div className="absolute inset-0 z-10 bg-gradient-to-t from-zinc-950 via-zinc-950/10 to-transparent" data-id="element-128"></div>
              <div className="absolute inset-0 z-10 bg-red-900/10 mix-blend-multiply opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-129"></div>

              <img src={item.src} alt={`Okrim Barber — ${item.label}`} loading="lazy" className="w-full h-full object-cover object-center contrast-105 saturate-[0.95] group-hover:scale-[1.06] transition-transform duration-[900ms] ease-out" data-id="element-130" />

              {/* Caption */}
              <div className="absolute bottom-0 left-0 right-0 z-20 p-5" data-id="element-131">
                <span className="inline-block text-[10px] font-display uppercase tracking-[0.25em] text-red-400 mb-1.5" data-id="element-132">
                  {item.tag}
                </span>
                <h3 className="font-display text-xl font-bold uppercase tracking-wide text-zinc-50 leading-tight" data-id="element-133">
                  {item.label}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}